// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2UGMU","header":"Messages_header__7bFK5"};